<template>
  <div>
    <v-row class="align-center">
      <v-col md="3">
        <app-text-search-field
          @input="handleSearchInput($event)"
          :loading="isLoading"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.due_date_start"
          label="Vencimento Inicial"
          @change="select(1)"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.due_date_end"
          label="Vencimento Final"
          @change="select(1)"
        />
      </v-col>

      <v-col class="text-right">
        <v-btn
          class="text-capitalize mr-6"
          bottom
          large
          outlined
          color="primary"
          @click="handleExportExcel()"
          >Exportar
        </v-btn>

        <v-btn
          class="text-capitalize"
          bottom
          large
          color="primary"
          v-if="$acl.can('billPayableCreateEdit')"
          @click="handleInsertBillPayable()"
          >Novo
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="3">
        <AccountPlanSelect
          v-model="searchParams.account_plan_id"
          :item-value="(val) => val.id"
          :dense="false"
          solo
          flat
          background-color="grey lighten-4"
          multiple
          clearable
          @change="select(1)"
        />
      </v-col>
      <v-col md="3">
        <company-select
          chips
          multiple
          v-model="searchParams.company_id"
          :item-value="(val) => val.id"
          :itemText="(val) => val.short_name"
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
          @change="select(1)"
        />
      </v-col>
      <v-col md="6">
        <v-chip-group
          v-model="searchParams.status"
          multiple
          mandatory
          @change="select(1)"
        >
          <v-chip filter outlined value="foreseen"> Previsão </v-chip>
          <v-chip filter outlined value="to_pay"> A Pagar </v-chip>
          <v-chip filter outlined value="scheduled"> Agendado </v-chip>
          <v-chip filter outlined value="paid"> Pago </v-chip>
          <v-chip filter outlined value="canceled"> Cancelado </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <v-card color="primary" elevation="0" dark class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between ">
            <div>
              Total
              <br />
              <b class="text-h5">{{
                $format.decimal(billPayablesSum.value_sum)
              }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card color="grey lighten-4" elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Previsão
              <br />
              <b class="text-h5">0,00</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card color="grey lighten-4" elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Previsão
              <br />
              <b class="text-h5">0,00</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card color="grey lighten-4" elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total Selecionado
              <small class="text--secondary" v-if="selectedCount > 0">
                ({{ selectedCount }})
              </small>
              <br />

              <div class="d-flex flex-column">
                <div class="">
                  <span class="text-caption text--secondary">A Pagar</span>
                  <b class="text-h6 font-weight-bold">
                    {{ $format.decimal(selectedToPaySum) }}
                  </b>
                </div>
                <div v-if="!canMakePayment && selected.length > 0">
                  <span class="text-caption text--secondary">Pago</span>
                  <b class="text-h6 font-weight-bold">
                    {{ $format.decimal(selectedPaidSum) }}
                  </b>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column align-center justify-end ga-3">
              <v-btn
                block
                :disabled="!canMakePayment || !$acl.can('payBillPayable')"
                class="text-capitalize w-100"
                color="primary"
                @click="handlePayBillPayable()"
              >
                Pagar
              </v-btn>
              <div class="text-center">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!canChangePaymentStatus || !$acl.can('payBillPayable')"
                      color="secondary"
                      class="mt-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Status
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list dense>
                      <v-list-item class="px-3 py-2">
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-subtitle-2 font-weight-medium"
                          >
                            Alterar Status
                          </v-list-item-title>
                          <v-list-item-subtitle class="mt-1">
                            Altere o status de {{ selectedCount }} conta{{
                              selectedCount > 1 ? "s" : ""
                            }}
                            selecionada{{ selectedCount > 1 ? "s" : "" }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-card-text class="pt-2 pb-2">
                      <v-radio-group v-model="statusSelected" class="mt-0">
                        <v-radio
                          v-for="status in statusToOptions"
                          :key="status.value"
                          :label="status.text"
                          :value="status.value"
                          class="mb-2"
                          dense
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>

                    <v-card-actions class="px-3 py-2">
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        @click="(menu = false), (statusSelected = null)"
                        class="mr-2"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="primary"
                        :disabled="!statusSelected"
                        @click="handleStatusBillPayableChange()"
                      >
                        Confirmar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="billPayables.data"
          :items-per-page="-1"
          :show-select="$acl.canView('payBillPayable')"
          v-model="selected"
          :options.sync="options"
          hide-default-footer
          @click:row="handleBillPayableRowClick($event)"
          @update:options="handleTableUpdate($event)"
        >
          <template v-slot:[`item.company`]="{ item }">
            <company-chip :company="item.company" />
          </template>
          <template v-slot:[`item.supplier_description`]="{ item }">
            <span v-if="item.supplier">{{ item.supplier.name }}</span>
            <span v-if="item.supplier && item.description"> | </span>
            {{ item.description }}
          </template>
          <template v-slot:[`item.value`]="{ item }">
            {{ $format.decimal(item.value) }}
          </template>
          <template v-slot:[`item.net_paid_value`]="{ item }">
            {{ $format.decimal(item.net_paid_value) }}
          </template>
          <template v-slot:[`item.due_date`]="{ item }">
            <app-due-date-label :due-date="item.due_date" />
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <bill-payable-status-chip :value="item.status" />
          </template>

          <!-- <template v-slot:item.empresa="{ item }">
            <v-chip small>{{ item.company.name }}</v-chip>
          </template> -->
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="searchParams.page"
            :length="billPayables.last_page"
            @input="select($event)"
            :total-visible="9"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <InsertBillPayableForm
      ref="InsertBillPayableForm"
      @store="select(searchParams.page)"
    />
    <UpdateBillPayableForm
      ref="UpdateBillPayableForm"
      @store="select(searchParams.page)"
    />
    <PayBillPayableForm
      ref="PayBillPayableForm"
      @store="handlePaymentStore()"
    />
    <BillPayableDialog ref="BillPayableDialog" />
  </div>
</template>

<script>
import CompanyChip from "@/components/company/sections/CompanyChip.vue";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
import AccountPlanSelect from "@/components/account-plan/ui/AccountPlanSelect.vue";
import BillPayableStatusChip from "@/components/bill-payable/sections/BillPayableStatusChip.vue";
import InsertBillPayableForm from "@/components/bill-payable/forms/InsertBillPayableForm";
import UpdateBillPayableForm from "@/components/bill-payable/forms/UpdateBillPayableForm";
import BillPayableDialog from "@/components/bill-payable/sections/BillPayableDialog";
import PayBillPayableForm from "@/components/bill-payable/forms/PayBillPayableForm";

export default {
  components: {
    CompanyChip,
    CompanySelect,
    AccountPlanSelect,
    BillPayableStatusChip,
    InsertBillPayableForm,
    UpdateBillPayableForm,
    BillPayableDialog,
    PayBillPayableForm,
  },

  data() {
    return {
      headers: [
        { text: "Empresa", value: "company", sortable: false },
        {
          text: "Fornecedor / Descrição",
          value: "supplier_description",
          sortable: false,
        },
        {
          text: "Plano de contas",
          value: "account_plan.name",
          sortable: false,
        },
        { text: "Documento", value: "document" },
        { text: "Valor", value: "value", align: "right" },
        { text: "V.Pago", value: "net_paid_value", align: "right" },
        { text: "Vencimento", value: "due_date", align: "center" },
        { text: "Status", value: "status", align: "center" },
      ],

      options: {},

      searchParams: {
        company_id: [],
        account_plan_id: [],
        text: null,
        page: 1,
        due_date_start: null,
        due_date_end: null,
        status: ["to_pay"],
        orderBy: null,
        orderDirection: null,
      },

      billPayables: {
        data: [],
        page: 1,
        per_page: 1,
      },

      billPayablesSum: {},

      selected: [],

      isLoading: false,

      statusToOptions: [
        { text: "Previsão", value: "foreseen" },
        { text: "A Pagar", value: "to_pay" },
        { text: "Agendado", value: "scheduled" },
        { text: "Cancelado", value: "canceled" },
      ],

      menu: false,
      statusSelected: null,
    };
  },

  mounted() {
    this.select(1);
  },

  computed: {
    selectedToPaySum() {
      return (
        this.$calc.sum(this.selected, "value") -
        this.$calc.sum(this.selected, "paid_value")
      );
    },

    selectedPaidSum() {
      return this.$calc.sum(this.selected, "paid_value");
    },

    selectedCount() {
      return this.selected.length;
    },

    canMakePayment() {
      let nonPayaybleBills = this.selected.filter(
        (row) => row.status != "to_pay" && row.status != "scheduled"
      );

      return this.selectedCount > 0 && nonPayaybleBills.length == 0;
    },

    canChangePaymentStatus() {
      let nonSchedulableBills = this.selected.filter(
        (row) => row.status == "paid"
      );

      return this.selectedCount > 0 && nonSchedulableBills.length == 0;
    },

    // value
    // paid_value
    // discount
    // addition
    // interest
    // net_paid_value
  },

  methods: {
    // sum(arr, field) {
    //   return arr.reduce((sum, row) => sum + parseFloat(row[field]), 0);
    // },

    handleExportExcel() {
      this.$loading.start();

      this.$http
        .download("bill-payable/bill-payable-export", this.searchParams)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Contas.xlsx`);
          document.body.appendChild(link);
          link.click();
          this.dialog = false;
          this.$loading.finish();
        })
        .catch((error) => {
          console.log(error);
          this.$loading.finish();
        });
    },

    async select(page = 1) {
      this.searchParams.page = page;
      this.options.page = page;
      this.isLoading = true;
      await this.$http
        .index("bill-payable/bill-payable", this.searchParams)
        .then((response) => {
          this.billPayables = response.billPayables;
          this.billPayablesSum = response.billPayablesSum;
        });
      this.isLoading = false;
    },

    handleTableUpdate(options) {
      this.options = options;
      this.searchParams.orderBy = options.sortBy[0];
      this.searchParams.orderDirection = options.sortDesc[0] ? "desc" : "asc";
      this.select(options.page);
    },

    handleSearchInput(text) {
      this.searchParams.text = text;
      this.select();
    },

    handleInsertBillPayable() {
      this.$refs.InsertBillPayableForm.open();
    },

    handlePayBillPayable() {
      this.$refs.PayBillPayableForm.open(this.selected);
    },

    handlePaymentStore() {
      this.selected = [];
      this.select(this.searchParams.page);
    },

    handleBillPayableRowClick(billPayable) {
      // sem permissão de edição (ou módulo somente leitura) abre só os detalhes
      if (this.hasPayments(billPayable) || !this.$acl.can("billPayableCreateEdit")) {
        this.$refs.BillPayableDialog.open(billPayable.id);
      } else {
        this.$refs.UpdateBillPayableForm.open(billPayable.id);
      }
    },

    hasPayments(billPayable) {
      return billPayable.paid_value != 0;
    },

    async handleStatusBillPayableChange() {
      let payload = {
        bill_ids: this.selected.map((i) => i.id),
        status: this.statusSelected,
      };

      try {
        await this.$http.store(
          "bill-payable/bill-payable-status-update",
          payload
        );

        this.selected = [];
        this.statusSelected = null;

        this.select(this.searchParams.page);
      } catch (error) {
        console.error("Error updating bill payables:", error);
      } finally {
        this.menu = false;
      }
    },
  },
};
</script>

<style></style>
